import {
  ADD_FAVOURITE,
  GET_FAVOURITES,
  REMOVE_FAVOURITE,
  SET_FAVOURITES,
  SET_USER_DATA,
  USER_LOG_OUT
} from '@flow/store/user/constants';

export const getFavourites = (params: GetFavouriteRequest) => {
  const {
    onComplete,
  } = params;

  return {
    type: GET_FAVOURITES,
    onComplete
  }
};

export const addToFavourites = (params: AddToFavouritesRequest) => {
  const {
    onComplete,
    ...rest
  } = params;

  return {
    type: ADD_FAVOURITE,
    onComplete,
    params: {
      favourite: {
        ...rest
      }
    }
  }
};

export const removeFromFavourites = (params: RemoveFromFavouritesRequest) => {
  const {
    onComplete,
    ...rest
  } = params;

  return {
    type: REMOVE_FAVOURITE,
    onComplete,
    params: rest
  }
};

export const setFavourites = (params: PutFavouriteRequest) => {
  const {
    onComplete,
    ...rest
  } = params;

  return {
    type: SET_FAVOURITES,
    onComplete,
    params: rest
  }
};

export const setUser = (params: UserData) => {
  return {
    type: SET_USER_DATA,
    params
  }
};

export const logOut = () => {
  return {
    type: USER_LOG_OUT
  }
};


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/user/actions.ts